@if (hasSearch) {
  <div class="form-group">
    <cpq-input #searchAvailableItems="ngModel" [label]="searchLabel" [name]="'searchAvailableItems'" [(ngModel)]='searchKeywordAvailable'
    (ngModelChange)="searchAvailable()"></cpq-input>
    <span class="sap-icon">&#xe00d;</span>
  </div>
}

@if (labelLink) {
  <p class="input-group no-top-margin">
    <a (click)="onLinkClick($event)">
      {{labelLink.key | translate}}
      <span class="sap-icon">&#xe202;</span>
    </a>
  </p>
}

<div class="multi-select-container cpq-scroll">
  @if (items && !items.length) {
    <div class="alert-info no-data">{{'Admin.NoDataAvailable' | translate}}</div>
  }
  <ul [(ngModel)]="selectedItems" ngDefaultControl>
    @for (item of items; track item) {
      @if (item.isVisible) {
        <li [class.selected]="item.selected" [class.read-only]="item.isReadOnly" (click)="selectedItem(item, $event)" title="{{item.text}}">
          <span class="item-text">
            {{item.text}}
          </span>
          @if (displayCheckMark) {
            <div class="arrow-container" [class.selected]="item.selected">
              <span class="sap-icon">&#xe05b;</span>
            </div>
          }
        </li>
      }
    }
  </ul>
</div>